const NAV_GROUP_LABELS = {
  operations: "Operations",
  finance: "Finance",
  masters: "Masters",
  insights: "Insights",
  admin: "Administration",
};
const NAV_GROUP_ORDER = [
  "top",
  "operations",
  "finance",
  "masters",
  "insights",
  "admin",
];
const appNavigation = [
  {
    name: "Group dashboard",
    href: "/app/dashboard/group",
    navId: "nav.groupDashboard",
    iconKey: "SpaceDashboard",
    module: "phase1",
    group: "top",
  },
  {
    name: "Company dashboard",
    href: "/app/dashboard/company",
    navId: "nav.companyDashboard",
    iconKey: "Dashboard",
    module: "phase1",
    group: "top",
  },
  {
    name: "Control tower",
    href: "/app/operations/tower",
    navId: "nav.controlTower",
    iconKey: "CellTower",
    module: "phase1",
    group: "operations",
  },
  {
    name: "Communication templates",
    href: "/app/operations/templates",
    navId: "nav.communicationTemplates",
    iconKey: "Message",
    module: "phase1",
    group: "operations",
  },
  {
    name: "Orders",
    href: "/app/orders",
    navId: "nav.orders",
    iconKey: "Assignment",
    module: "phase1",
    group: "operations",
  },
  {
    name: "Vehicle board",
    href: "/app/planning/vehicles",
    navId: "nav.vehicleBoard",
    iconKey: "LocalShipping",
    module: "phase1",
    group: "operations",
  },
  {
    name: "Container planner",
    href: "/app/planning/containers",
    navId: "nav.containerPlanner",
    iconKey: "Inventory2",
    module: "phase1",
    group: "operations",
  },
  {
    name: "Dispatch sheet",
    href: "/app/planning/dispatch",
    navId: "nav.dispatchSheet",
    iconKey: "Map",
    module: "phase1",
    group: "operations",
  },
  {
    name: "Conflicts",
    href: "/app/planning/conflicts",
    navId: "nav.conflicts",
    iconKey: "WarningAmber",
    module: "phase1",
    group: "operations",
  },
  {
    name: "Trips",
    href: "/app/trips",
    navId: "nav.trips",
    iconKey: "LocalShipping",
    module: "phase1",
    group: "operations",
  },
  {
    name: "Trip history",
    href: "/app/trips/history",
    navId: "nav.tripHistory",
    iconKey: "History",
    module: "phase1",
    group: "operations",
  },
  {
    name: "Trip exceptions",
    href: "/app/trips/exceptions",
    navId: "nav.tripExceptions",
    iconKey: "WarningAmber",
    module: "phase1",
    group: "operations",
  },
  {
    name: "Trip closure",
    href: "/app/trips/closure",
    navId: "nav.tripClosure",
    iconKey: "TaskAlt",
    module: "phase1",
    group: "operations",
    roles: ["group_admin", "operations", "accountant"],
  },
  {
    name: "POD inbox",
    href: "/app/pod",
    navId: "nav.pODInbox",
    iconKey: "Description",
    module: "phase1",
    group: "operations",
  },
  {
    name: "WhatsApp",
    href: "/app/operations/whatsapp",
    navId: "nav.whatsApp",
    iconKey: "WhatsApp",
    module: "phase1",
    group: "operations",
  },
  {
    name: "My tasks",
    href: "/app/office/tasks",
    navId: "nav.myTasks",
    iconKey: "Assignment",
    module: "phase2",
    group: "operations",
  },
  {
    name: "Department board",
    href: "/app/office/department-board",
    navId: "nav.departmentBoard",
    iconKey: "Checklist",
    module: "phase2",
    group: "operations",
  },
  {
    name: "Approvals",
    href: "/app/office/approvals",
    navId: "nav.approvals",
    iconKey: "Gavel",
    module: "phase2",
    group: "operations",
  },
  {
    name: "Follow-ups",
    href: "/app/office/follow-ups",
    navId: "nav.followups",
    iconKey: "Assignment",
    module: "phase2",
    group: "operations",
    roles: ["group_admin", "accountant"],
  },
  {
    name: "Promise to pay",
    href: "/app/office/promise-to-pay",
    navId: "nav.promiseToPay",
    iconKey: "Handshake",
    module: "phase2",
    group: "finance",
    roles: ["group_admin", "accountant"],
  },
  {
    name: "Reminders",
    href: "/app/office/reminders",
    navId: "nav.reminders",
    iconKey: "Notifications",
    module: "phase2",
    group: "operations",
  },
  {
    name: "Escalations",
    href: "/app/office/escalations",
    navId: "nav.escalations",
    iconKey: "WarningAmber",
    module: "phase2",
    group: "operations",
  },
  {
    name: "Escalation rules",
    href: "/app/office/escalation-rules",
    navId: "nav.escalationRules",
    iconKey: "Rule",
    module: "phase2",
    group: "operations",
    roles: ["group_admin"],
  },
  {
    name: "Collector performance",
    href: "/app/office/collector-performance",
    navId: "nav.collectorPerformance",
    iconKey: "MonetizationOn",
    module: "phase2",
    group: "finance",
    roles: ["group_admin", "accountant"],
  },
  {
    name: "Document repository",
    href: "/app/office/documents",
    navId: "nav.documentRepository",
    iconKey: "FolderOpen",
    module: "phase2",
    group: "operations",
  },
  {
    name: "Drivers",
    href: "/app/fleet/drivers",
    navId: "nav.drivers",
    iconKey: "Person",
    module: "phase3",
    group: "operations",
  },
  {
    name: "Fleet vehicles",
    href: "/app/fleet/vehicles",
    navId: "nav.fleetVehicles",
    iconKey: "DirectionsCar",
    module: "phase3",
    group: "operations",
  },
  {
    name: "Fuel",
    href: "/app/fleet/fuel",
    navId: "nav.fuel",
    iconKey: "LocalGasStation",
    module: "phase3",
    group: "operations",
  },
  {
    name: "Route performance",
    href: "/app/fleet/routes",
    navId: "nav.routePerformance",
    iconKey: "Route",
    module: "phase3",
    group: "operations",
  },
  {
    name: "Utilization",
    href: "/app/fleet/utilization",
    navId: "nav.utilization",
    iconKey: "LocalShipping",
    module: "phase3",
    group: "operations",
  },
  {
    name: "Maintenance requests",
    href: "/app/workshop/maintenance",
    navId: "nav.maintenanceRequests",
    iconKey: "Build",
    module: "phase4",
    group: "operations",
    roles: ["group_admin", "workshop_manager", "operations"],
  },
  {
    name: "Job cards",
    href: "/app/workshop/job-cards",
    navId: "nav.jobCards",
    iconKey: "Handyman",
    module: "phase4",
    group: "operations",
    roles: ["group_admin", "workshop_manager"],
  },
  {
    name: "Service schedule",
    href: "/app/workshop/service-schedule",
    navId: "nav.serviceSchedule",
    iconKey: "EventRepeat",
    module: "phase4",
    group: "operations",
    roles: ["group_admin", "workshop_manager"],
  },
  {
    name: "Spares & inventory",
    href: "/app/workshop/inventory",
    navId: "nav.sparesAndInventory",
    iconKey: "Inventory",
    module: "phase4",
    group: "operations",
    roles: ["group_admin", "workshop_manager"],
  },
  {
    name: "Breakdowns",
    href: "/app/workshop/breakdowns",
    navId: "nav.breakdowns",
    iconKey: "WarningAmber",
    module: "phase4",
    group: "operations",
    roles: ["group_admin", "workshop_manager", "operations"],
  },
  {
    name: "Vendor bills",
    href: "/app/workshop/vendor-bills",
    navId: "nav.vendorBills",
    iconKey: "ReceiptLong",
    module: "phase4",
    group: "operations",
    roles: ["group_admin", "workshop_manager"],
  },
  {
    name: "Downtime",
    href: "/app/workshop/downtime",
    navId: "nav.downtime",
    iconKey: "TimerOff",
    module: "phase4",
    group: "operations",
    roles: ["group_admin", "workshop_manager"],
  },
  {
    name: "Workshop estimates",
    href: "/app/workshop/estimates",
    navId: "nav.workshopEstimates",
    iconKey: "Gavel",
    module: "phase4",
    group: "operations",
    roles: ["group_admin", "workshop_manager"],
  },
  {
    name: "Workshop escalations",
    href: "/app/workshop/escalations",
    navId: "nav.workshopEscalations",
    iconKey: "WarningAmber",
    module: "phase4",
    group: "operations",
    roles: ["group_admin", "workshop_manager"],
  },
  {
    name: "Workshop reports",
    href: "/app/workshop/reports",
    navId: "nav.workshopReports",
    iconKey: "Assessment",
    module: "phase4",
    group: "operations",
    roles: ["group_admin", "workshop_manager"],
  },
  {
    name: "Invoice queue",
    href: "/app/invoices",
    navId: "nav.invoiceQueue",
    iconKey: "Description",
    module: "phase1",
    group: "finance",
  },
  {
    name: "Billing adjustments",
    href: "/app/finance/billing-adjustments",
    navId: "nav.billingAdjustments",
    iconKey: "Description",
    module: "phase1",
    group: "finance",
    roles: ["group_admin", "accountant"],
  },
  {
    name: "Collection dashboard",
    href: "/app/finance/collections",
    navId: "nav.collectionDashboard",
    iconKey: "AccountBalanceWallet",
    module: "phase1",
    group: "finance",
    roles: ["group_admin", "accountant"],
  },
  {
    name: "Collection follow-up",
    href: "/app/finance/collection-follow-ups",
    navId: "nav.collectionFollowup",
    iconKey: "MonetizationOn",
    module: "phase1",
    group: "finance",
    roles: ["group_admin", "accountant"],
  },
  {
    name: "Ledger",
    href: "/app/finance/ledger",
    navId: "nav.ledger",
    iconKey: "AccountBalance",
    module: "phase1",
    group: "finance",
  },
  {
    name: "Receipt entry",
    href: "/app/finance/receipts",
    navId: "nav.receiptEntry",
    iconKey: "Receipt",
    module: "phase1",
    group: "finance",
    roles: ["group_admin", "accountant"],
  },
  {
    name: "Ageing",
    href: "/app/finance/ageing",
    navId: "nav.ageing",
    iconKey: "Schedule",
    module: "phase1",
    group: "finance",
  },
  {
    name: "Client feedback",
    href: "/app/insights/feedback",
    navId: "nav.clientFeedback",
    iconKey: "Feedback",
    module: "phase5",
    group: "insights",
    roles: ["group_admin"],
  },
  {
    name: "Report library",
    href: "/app/insights/reports",
    navId: "nav.reportLibrary",
    iconKey: "Assessment",
    module: "phase5",
    group: "insights",
    roles: ["group_admin", "accountant"],
  },
  {
    name: "Scheduled exports",
    href: "/app/insights/scheduled-exports",
    navId: "nav.scheduledExports",
    iconKey: "Schedule",
    module: "phase5",
    group: "insights",
    roles: ["group_admin", "accountant"],
  },
  {
    name: "Workflow notes",
    href: "/app/insights/workflow-notes",
    navId: "nav.workflowNotes",
    iconKey: "Notes",
    module: "phase5",
    group: "insights",
    roles: ["group_admin"],
  },
  {
    name: "Recommendations",
    href: "/app/insights/recommendations",
    navId: "nav.recommendations",
    iconKey: "AutoAwesome",
    module: "phase5",
    group: "insights",
    roles: ["group_admin"],
  },
  {
    name: "Company master",
    href: "/app/masters/company",
    navId: "nav.companyMaster",
    iconKey: "Storage",
    module: "phase1",
    group: "masters",
  },
  {
    name: "Customer master",
    href: "/app/masters/customers",
    navId: "nav.customerMaster",
    iconKey: "Public",
    module: "phase1",
    group: "masters",
  },
  {
    name: "Ports & materials",
    href: "/app/masters/reference",
    navId: "nav.portsAndMaterials",
    iconKey: "Storage",
    module: "phase1",
    group: "masters",
  },
  {
    name: "Company & letterhead",
    href: "/app/admin/company-letterhead",
    navId: "nav.companyAndLetterhead",
    iconKey: "Business",
    module: "phase1",
    group: "admin",
    roles: ["group_admin"],
  },
  {
    name: "Access admin",
    href: "/app/admin/access",
    navId: "nav.accessAdmin",
    iconKey: "Security",
    module: "phase1",
    group: "admin",
    roles: ["group_admin"],
  },
  {
    name: "Customer roles",
    href: "/app/admin/customer-permissions",
    navId: "nav.customerRoles",
    iconKey: "Shield",
    module: "phase1",
    group: "admin",
    roles: ["group_admin"],
  },
  {
    name: "Settings",
    href: "/app/settings",
    navId: "nav.settings",
    iconKey: "Settings",
    module: "phase1",
    group: "admin",
  },
];
export { NAV_GROUP_LABELS, NAV_GROUP_ORDER, appNavigation };
